/* eslint-disable react/no-unescaped-entities */
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";

const Teaser = ({ imageLeft, txt, subtitle, title, titleWord, imgSrc }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  const { t } = useTranslation();

  const img = (
    <Grid
      item
      container
      justifyContent="center"
      alignItems="center"
      xs={12}
      md={6}
    >
      <Box maxWidth={490} width={1}>
        <Box
          component={"img"}
          src={imgSrc}
          maxHeight="200"
          sx={{
            filter: theme.palette.mode === "dark" ? "brightness(0.8)" : "none",
          }}
        />
      </Box>
    </Grid>
  );

  return (
    <Box>
      <Grid container spacing={4} direction={isMd ? "row" : "column"}>
        {imageLeft && img}
        <Grid
          item
          container
          alignItems={"center"}
          xs={12}
          md={6}
          data-aos={isMd ? "fade-right" : "fade-up"}
        >
          <Box>
            <Typography
              sx={{
                textTransform: "uppercase",
                fontWeight: "medium",
              }}
              gutterBottom
              color={"secondary"}
            >
              {subtitle}
            </Typography>
            <Typography
              variant={"h4"}
              gutterBottom
              sx={{ fontWeight: 700, marginRight: 2 }}
            >
              {title}
              <Typography color="primary" variant="inherit" component="span">
                <br></br>
                {titleWord}
              </Typography>
            </Typography>
            <Typography variant={"h6"} component={"p"} color={"text.secondary"}>
              {txt}
            </Typography>
          </Box>
        </Grid>
        {!imageLeft && img}
      </Grid>
    </Box>
  );
};

export default Teaser;
